module.controller('mobileIdSuccessCtrl', ['$scope', '$state', '$http','baseURI', 'Transform', '$window', 'Session', function($scope, $state, $http, baseURI, Transform, $window, Session){

  $scope.title = 'Mobile ID';
  $scope.info = 'Info';
  $scope.helperText = 'Helper';

  var mobileIdUrl = baseURI + 'mobile-id';

  var p = $state.params;

  var body = {
    Code: p.code,
    State: p.state,
  };

  $http({
    method: 'POST',
    url: mobileIdUrl,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    data: Transform.encode(body)
  }).then(function (resp){
    $state.go('root.mobileid.collect', {
      RedeemCode: resp.data.Data.RedeemCode,
      State: p.state,
      SHash: ipCookie('s_hash'),
    });
  }).catch(function(error){
    console.log(error);
  });
}]);


